import styled from "styled-components"
import {Modal} from "react-bootstrap"

const SearchModal = styled(Modal)`
  .searchModal_input:after {
    content: "\E833";
  }

  .modal-content {
    margin: 0 auto;
    width: 100%;
    padding: 0 15px;
  }

  .modal-dialog {
    width: auto;
  }

  .searchModal_wrapper {
    position: relative;
    padding: 20px 0;
  }

  @media(min-width: 768px) {
    .modal-content {
      width: ${(props) => props.width};
      padding: 0 45px;
    }
  }

  .searchModal_input {
    border: 0;

    &:focus {
      outline: none;
    }
  }

  .searchModal_icon {
    font-size: 30px;

    &:before {
      position: absolute;
      top: 25px;
    }
  }  
`

export default SearchModal
